export enum SpotlightStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  Draft = 'Draft',
}

export enum SpotlightType {
  HAPPY_HOUR = 'Happy Hour',
  ONLINE_ORDERING = 'Online Ordering',
  CATERING = 'Catering',
  RESERVATIONS = 'Reservations',
  GIFT_CARDS = 'Gift Cards',
  LOYALTY = 'Loyalty',
  CUSTOM_SPOTLIGHT = 'Custom Spotlight',
}

export interface ISpotlightDataResponse {
  id: number;
  type: SpotlightType;
  status: SpotlightStatus;
  title: string;
  description: string;
  link: string;
  images?: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface IGetSpotlightResponseType {
  response: {
    success: boolean;
    data: { spotlights: ISpotlightDataResponse[] | null; total: number };
    message: string;
    error?: string | null;
  };
  statusCode: number;
}

export interface ISpotlightBaseResponseType {
  response: {
    success: boolean;
    message: string;
    error?: string | null;
  };
  statusCode: number;
}

export interface ISpotlightCreateResponseType extends ISpotlightBaseResponseType {
  response: {
    success: boolean;
    message: string;
    error?: string | null;
    data: { spotlight: ISpotlightDataResponse; campaignName: string };
  };
  statusCode: number;
}
